import Container from "@mui/material/Container"
import { useTranslation } from "react-i18next"

import { API_URL } from "features/config"

import ApiDocEn from "./ApiDoc.en"
import ApiDocEs from "./ApiDoc.es"

export default function APIDoc() {
  const { i18n } = useTranslation()
  const userLanguage = i18n.resolvedLanguage

  const url = API_URL.replace(/\/+$/, "")

  return (
    <Container maxWidth="xl" disableGutters>
      {userLanguage?.includes("es") ? <ApiDocEs url={url} /> : <ApiDocEn url={url} />}
    </Container>
  )
}
